import React, { useEffect, useRef } from 'react';
import { Column, FilterRow, Pager, Paging } from 'devextreme-react/data-grid';
import { ScrollView, DataGrid, DateBox } from 'devextreme-react';
import { Popup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import { ExcelExport } from '../../common/excel';
import moment from 'moment';
import { FormatLineNumber, FormatNumber } from '../../common';

const CorpListExcelRegisterListPopup = ({
  onHiding,
  onClickExcelRegister,
  excelRegisterList,
  visibleExcelRegisterListPopup,
}) => {
  // console.log('CorpListExcelRegisterListPopup Load');

  return (
    <React.Fragment>
      <Popup
        title="법인 사용자 등록 리스트"
        className="popup"
        height="90vh"
        visible={visibleExcelRegisterListPopup}
        onHiding={onHiding}
      >
        <ScrollView>
          <div className="corp-list-excel-register-list-content popup-content">
            <DataGrid
              className={'dx-card wide-card'}
              columnAutoWidth={true}
              dataSource={excelRegisterList}
              focusedRowEnabled={false}
              noDataText="등록할 사용자가 존재하지 않습니다."
              showBorders={true}
            >
              <FilterRow visible={false} />
              <Column
                dataField="LineNumber"
                caption="전화번호"
                alignment="center"
                customizeText={(e) => FormatLineNumber(e.value)}
                width="130px"
              />
              <Column dataField="Name" caption="성명" alignment="center" />
              <Column dataField="Dong" caption="일반주소" alignment="left" />
              <Column dataField="Address" caption="상세주소" alignment="left" />
              <Column dataField="Part" caption="부서" alignment="center" />
              <Column dataField="Duty" caption="직책" alignment="center" />
              <Column
                dataField="UseCheckName"
                caption="한도구분"
                alignment="center"
              />
              <Column
                dataField="UseCheckValueName"
                caption="금액/횟수"
                alignment="center"
              />
              <Column
                dataField="RegCheckName"
                caption="등록가능여부"
                alignment="center"
                cellRender={(cellData) => {
                  return (
                    <div
                      className={
                        cellData.data['RegCheck'] === 0 ||
                        cellData.data['RegCheck'] === 1
                          ? 'valid_value'
                          : 'invalid_value'
                      }
                    >
                      {cellData.data['RegCheckName']}
                    </div>
                  );
                }}
              />
              <Paging defaultPageSize={10} enabled={false} />
              <Pager showPageSizeSelector={false} showInfo={false} />
            </DataGrid>
          </div>
          <div className="corp-list-excel-register-list-bottom">
            <Button
              stylingMode="contained"
              type="success"
              text="등록"
              onClick={onClickExcelRegister}
            />
            <Button
              stylingMode="contained"
              type="normal"
              text="닫기"
              onClick={onHiding}
            />
          </div>
        </ScrollView>
      </Popup>
    </React.Fragment>
  );
};

export default React.memo(CorpListExcelRegisterListPopup);
